import React from 'react'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faPlay ,faPause, faBackward, faForward, faVolumeHigh,faVolumeMute} from '@fortawesome/free-solid-svg-icons';

function PlayerControl(props) {

  const updateTime = (value)=>{
    props.audioEl.current.currentTime = value;
  }

  return (
    <>
        <div className="timestamp px-4">
            <span className="date"> {props.time || 0}</span>
            {
              props.time?
              <>
                <input type="range" className="range mx-2" min="0" max={props.duration} onChange={(e)=>updateTime(e.target.value)} value={props.time}/>
                <span className="date">{props.duration}</span>
              </>
              :
              ""
            }
        </div>
        <div className="control">
            {/* <button className="skip_btn" onClick={()=>props.skipSong(false)}><FontAwesomeIcon icon={faBackward}/></button> */}
            <button className="play_btn" onClick={()=>props.setPlaying(!props.isPlaying)}><FontAwesomeIcon icon={props.isPlaying?faPause:faPlay}/></button>
            {/* <button className="skip_btn" onClick={()=>props.skipSong()}><FontAwesomeIcon icon={faForward}/></button> */}
            <button className="skip_btn px-3" onClick={()=>props.setMute(!props.isMute)}><FontAwesomeIcon icon={props.isMute? faVolumeMute : faVolumeHigh}/></button>
        </div>
    </>
  )
}

export default PlayerControl